import Routerconfig from './routes'

function App() {
    return (
        <div className='App'>
            <Routerconfig />
        </div>
    )
}
export default App
